import { checkBackendHealth } from '@/utils/BackendHealth';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;

export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async (credentials, { rejectWithValue }) => {
    const backendAlive = await checkBackendHealth();
    if (!backendAlive) {
      return rejectWithValue('BACKEND_UNAVAILABLE');
    }

    try {
      const res = await axios.post(`${API_URL}/auth/login`, credentials);
      return res.data;
    }
    catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

export const refreshAccessToken = createAsyncThunk(
  'auth/refreshToken',
  async (refreshToken) => {
    const res = await axios.post(`${API_URL}/auth/refresh`, { refreshToken });
    return res.data;
  },
);
